<template>
	<article class="itv-datepicker">
		<datepicker-desktop-config
			v-if="!isMobile"
			:min-date="minDate"
			:max-date="maxDate"
			:start-date="startDate"
			:name="name"
			@change-date="datepickerHandler"
		/>
		<datepicker-mobile-config
			v-else
			:min-date="minDate"
			:max-date="maxDate"
			:start-date="startDate"
			:name="name"
			@change-date="datepickerHandler"
		/>
	</article>
</template>

<script>
import DatepickerDesktopConfig from './DatepickerDesktopConfig'
import DatepickerMobileConfig from './DatepickerMobileConfig'

export default {
	name: 'Datepicker',
	components: {
		DatepickerDesktopConfig,
		DatepickerMobileConfig,
	},
	props: {
		minDate: {
			type: String,
			default: '',
		},
		maxDate: {
			type: String,
			default: '',
		},
		startDate: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: 'date',
		},
	},
	computed: {
		isMobile() {
			return window.innerWidth < 768
		},
	},
	methods: {
		datepickerHandler(val, output) {
			if (!val) {
				this.$emit('change-date', val, output)
				return
			}

			const options = {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric',
			}

			this.$emit('change-date', val.toLocaleString('ru', options), output)
		},
	},
}
</script>
